import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { isMobileDevice } from "./utils/deviceDetection";
import DesktopBlocker from "./components/DesktopBlocker";

function Main() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const isMobile = isMobileDevice();

    useEffect(() => {
        // Wait for AuthContext to resolve the session before deciding where to go.
        // Email-verification links land here as `/#access_token=...`; redirecting on the
        // first render (when user is still null) throws that session away and dumps a
        // freshly verified user back on /sign-in. ProtectedRoute guards the same way.
        if (loading) return;

        if (isMobile) {
            if (user) {
                const role = String(user.user_metadata?.role);
                if (role === '4') {
                    navigate('/admin', { replace: true });
                } else {
                    navigate('/welcome', { replace: true });
                }
            } else {
                navigate('/sign-in', { replace: true });
            }
        } else if (user && String(user.user_metadata?.role) === '4') {
            navigate('/admin', { replace: true });
        }
    }, [user, loading, navigate, isMobile]);

    // Desktop non-admin users (or not logged in) see the blocker
    if (!isMobile) {
        return <DesktopBlocker><div /></DesktopBlocker>;
    }

    return null;
}

export default Main;